/** @jsx jsx */
import { jsx, Box, Container, Flex } from "theme-ui";
import { Themed } from "@theme-ui/mdx";
import { Link as GatsbyLink } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import PageSection from "./PageSection";
import Laptop from "./Laptop";

const BlogPostCta = () => {
  return (
    <PageSection sx={{
      backgroundColor: "backgroundLight.1"
    }}>
      <Container sx={{
        display: "flex",
        flexDirection: ["column", "column", "row"],
        alignItems: ["center", "center", "flex-start"],
      }}>
        <Box sx={{flexBasis: ["60%", "60%", "50%", "60%"], order: [2, 2, 1]}}>
          <Themed.h1 sx={{ color: "textDark.0", mt: 0, mb: 4 }}>
            Looking for a better file manager?
          </Themed.h1>
          <Themed.p sx={{color: "textDark.1", fontSize: "ingress", mb: 2}}>
            Fileside is a modern multi-pane file manager for Mac and Windows.
          </Themed.p>
          <Themed.p sx={{color: "textDark.3", mb: 5}}>
            Its customisable workspaces of tiled panes make it a breeze to keep your projects and collections organised.
          </Themed.p>
          <Flex sx={{flexDirection: "row"}}>
            <GatsbyLink to="/" sx={{variant: "buttons.primary", mr: 4}}>
              Learn more
            </GatsbyLink>
            <GatsbyLink to="/download/" sx={{variant: "buttons.secondary"}}>
              Try it now
            </GatsbyLink>
          </Flex>
        </Box>

        <Laptop sx={{
          // Without this, image gets 0 width in a flex row
          flexBasis: ["40%", "40%", "50%", "40%"],
          order: [1, 1, 2],
          maxWidth: "450px",
          ml: [0, 0, 6],
          mb: [6, 6, 0]
        }}>
          <StaticImage 
            src="../../content/assets/1.5.0-overview.png" 
            alt="Laptop showing Fileside running"
            width={550} // max width
            quality={80}
            sx={{
              borderRadius: "3px"
            }}
          />
        </Laptop>

      </Container>
    </PageSection>
  );

};

export default BlogPostCta;
